import { render, staticRenderFns } from "./recCodeDetail.vue?vue&type=template&id=29d92daa&"
import script from "./recCodeDetail.vue?vue&type=script&lang=js&"
export * from "./recCodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports